/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNavigationEast = createReactComponent("outline", "navigation-east", "IconNavigationEast", [["path", { "d": "M14 3h-4v6h4", "key": "svg-0" }], ["path", { "d": "M10 6h2.5", "key": "svg-1" }], ["path", { "d": "M16 21l-4 -8l-4 8l4 -2z", "key": "svg-2" }]]);

export { IconNavigationEast as default };
//# sourceMappingURL=IconNavigationEast.mjs.map
